// extracted by mini-css-extract-plugin
export default {"loading":"modalUploadTemplate_loading__Eg9HX","dots":"modalUploadTemplate_dots__1Q4-H"};